import { render } from "./PencilSvg.vue?vue&type=template&id=20b45f25"
import script from "./PencilSvg.vue?vue&type=script&lang=js"
export * from "./PencilSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__